import { c as _c } from "react/compiler-runtime";
import { CURRENCIES } from '@repo/sdk/constants';
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormCurrencySelect = t0 => {
  const $ = _c(24);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = CURRENCIES.map(_temp);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== field) {
    t5 = val => field.handleChange(val);
    $[1] = field;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = field.state.value;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = dataTestId ?? "form-currency-select-trigger";
  let t9;
  if ($[4] !== placeholder) {
    t9 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-currency-select.tsx" />;
    $[4] = placeholder;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== isPending) {
    t10 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[6] = isPending;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== t10 || $[9] !== t8 || $[10] !== t9 || $[11] !== variant) {
    t11 = <SelectTrigger className={t7} data-testid={t8} hideChevron={true} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-currency-select.tsx">{t9}{t10}</SelectTrigger>;
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
    $[11] = variant;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-currency-select.tsx">{CURRENCIES.map(_temp2)}</SelectContent>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== field.state.value || $[15] !== isPending || $[16] !== t11 || $[17] !== t5) {
    t13 = <div className="relative"><Select disabled={isPending} items={t4} onValueChange={t5} value={t6} data-sentry-element="Select" data-sentry-source-file="form-currency-select.tsx">{t11}{t12}</Select></div>;
    $[14] = field.state.value;
    $[15] = isPending;
    $[16] = t11;
    $[17] = t5;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== field.state.meta.errors) {
    t14 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-currency-select.tsx" />;
    $[19] = field.state.meta.errors;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13 || $[22] !== t14) {
    t15 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormCurrencySelect" data-sentry-source-file="form-currency-select.tsx">{t13}{t14}</Field>;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
};
function _temp(currency) {
  return {
    label: currency.title,
    value: currency.alias
  };
}
function _temp2(currency_0) {
  return <SelectItem data-testid={`form-currency-select-option-${currency_0.alias}`} key={currency_0.alias} value={currency_0.alias}>{currency_0.title}</SelectItem>;
}